import { render } from "./App.vue?vue&type=template&id=f388d926&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=f388d926&scoped=true&lang=css"
import "./App.vue?vue&type=style&index=1&id=f388d926&lang=css"

import exportComponent from "/home/cms/prod/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f388d926"]])

export default __exports__